import * as Immutable from 'immutable';
import type GoalToastStore from './GoalToastStore';
import type { ToastSeverity } from '../_actions/UIDataActions';

export interface IToast {
	key: string
	message: string
	new: boolean
	goalData: GoalToastStore|null
	severity: ToastSeverity|null
}

const defaultStore = Immutable.Record<IToast>({
	key: '',
	message: "",
	new: false,
	goalData: null,
	severity: null,
});

export default class UIToastStore extends defaultStore implements IToast {}
